/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BaseMongoEntity } from './baseMongoEntity';
import { DayOfWeek } from './dayOfWeek';
import { EntityStatus } from './entityStatus';
import { PlanInterval } from './planInterval';


export interface ServicePlanModel extends BaseMongoEntity { 
    creatorId?: string;
    planName?: string;
    planId?: string;
    planInterval: PlanInterval;
    dayOfMonth?: number;
    dayOfWeek: DayOfWeek;
    hour?: number;
    minute: number;
    seconds: number;
    active: boolean;
    price: number;
    cronTab?: string;
}
